export const trimAddr = (addr: string, n = 6) =>
  addr?.substring(0, 7) + "..." + addr?.slice(-n);
